import { InputDefinition } from '../../interface'

export const restorePasswordDefinition: InputDefinition[] = [
  {
    id: 'email',
    inputType: 'text',
    name: 'email',
    label: 'Email Użytkownika',
    placeholder: 'Wpisz email użytkownika',
    autoComplete: 'email'
  }
]
